import React from 'react'
import Find from '../share/components/Find/Find'
import CarouselSevices, { servicesTravel } from '../share/components/CarouselServices/CarouselSevices'
import UseCosmetics from '../../viewModels/Cosmetics/UseCosmetics'
import AllCardsCosmetics from './AllCards/AllCardsCosmetics'
import Paginado from './Paginado/Paginado'

const Cosmetics = () => {

const {
    dataCosmetics,
    loading,
    nextHandler,
    prevHandler,
    currentPage,
    mostrarNext,
    services,
    urlImage,
    detailCosmetics
} = UseCosmetics()

  return (
    <div>
       <Find/>
       <CarouselSevices current={servicesTravel[11].title}/>
       <AllCardsCosmetics
            dataCosmetics={dataCosmetics}
            loading={loading}
            urlImage={urlImage}
            detailCosmetics={detailCosmetics}
       />
       <Paginado currentPage={currentPage} data={services} mostrarNext={mostrarNext} prevHandler={prevHandler} nextHandler={nextHandler}/>
    </div>
  )
}

export default Cosmetics